/** @jsxImportSource @emotion/react */
'use memo'

import css from '@emotion/css/macro'
import { UserOutlined } from '@ant-design/icons'
import colors from '@sportninja/common/constants/appColors'
import { ROUTES } from '@sportninja/common/constants/app'
import { NO_PLAYER_PROFILE_GUIDANCE } from '@sportninja/common/features/profile/finderSettings/guidance'
import { capitalizeWords } from '@sportninja/common/ts-utils'
import { useHistory } from 'react-router-dom'
import Button from 'src/components/ts-components/Button'
import Text from 'src/components/ts-components/Text'

/**
 * Profile empty state shown when the user has no associated player profiles.
 * View-only — the gating decision lives in ProfilePage via
 * `hasNoAssociatedPlayers`. SN-8294: says how a player profile comes about and
 * what Player Finder does, and points to Team Finder.
 */
const NoPlayerProfile = () => {
  const history = useHistory()

  return (
    <div css={cardStyle}>
      <div css={contentStyle}>
        <UserOutlined css={iconStyle} />
        <Text variant='paragraphLarge' weight='medium' color={colors.NEUTRAL_0}>
          {capitalizeWords(NO_PLAYER_PROFILE_GUIDANCE.title)}
        </Text>
        <Text variant='paragraphXSmall' color={colors.NEUTRAL_50}>
          {NO_PLAYER_PROFILE_GUIDANCE.howToGetOne}
        </Text>
        <Text variant='paragraphXSmall' color={colors.NEUTRAL_50}>
          {NO_PLAYER_PROFILE_GUIDANCE.playerFinder}
        </Text>
        <div css={actionStyle}>
          <Button
            text={capitalizeWords(NO_PLAYER_PROFILE_GUIDANCE.action)}
            variant='primary'
            onClick={() => history.push(ROUTES.TEAM_FINDER)}
          />
        </div>
      </div>
    </div>
  )
}

export default NoPlayerProfile

const cardStyle = css`
  width: 100%;
  min-height: 250px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 16px;
  border-radius: 8px;
  background-color: ${colors.SECONDARY_400};
`

const contentStyle = css`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 16px;
  max-width: 560px;
  text-align: center;
`

const iconStyle = css`
  font-size: 40px;
  color: ${colors.NEUTRAL_100};
`

// The CTA hugs its label instead of stretching (the shared Button is flex: 1).
const actionStyle = css`
  display: flex;
  justify-content: center;
  margin-top: 8px;
`
